module.exports = __webpack_public_path__ + "static/media/fileSetLabel.0b1f54bc.graphql";